import JsonApi from "devour-client";
import config from "@/config";
import store from "@/store";

const clientApi = new JsonApi({
  apiUrl: config.client_api_endpoint,
  pluralize: false,
});

clientApi.define("user_groups", {
  name: "",
  scopes: "",
  created_at: "",
  updated_at: "",
});

clientApi.define("user_consents", {
  key: "",
  created_at: ""
});

clientApi.define("users", {
  email: "",
  password: "",
  first_name: "",
  last_name: "",
  created_at: "",
  updated_at: "",
  locale: "",
  all_carriers: true,
  all_order_channels: true,
  user_group: {
    jsonApi: "hasOne",
    type: "user_groups",
  },
  consents: {
    jsonApi: "hasMany"
  }
});

clientApi.define("carriers", {
  alias: "",
  attrs: [],
  carrier_type: {
    jsonApi: "hasOne",
    type: "carrier_types",
  },
});

clientApi.define("order_channels", {
  channel_label: "",
  attrs: [],
  additional_parameters: {},
  order_channel_type: {
    jsonApi: "hasOne",
    type: "order_channel_types",
  },
  sender_address: {
    jsonApi: "hasOne",
    type: "shipping_addresses",
  },
});

clientApi.define("reset_customers", {});

clientApi.define("shipping_addresses", {
  att_contact: "",
  company_name: "",
  address_1: "",
  address_2: "",
  zip: "",
  city: "",
  country_code: "",
  phone: "",
  email: "",
  address_type: null,
  vat_no: "",
  state: null,
  ext_location: "",
});

clientApi.define("shipping_rates", {
  carrier_service_code: "",
  name: "",
  is_return: false,
  require_drop_point: false,
  carrier: {
    jsonApi: "hasOne",
    type: "carriers",
  },
  order_channel: {
    jsonApi: "hasOne",
    type: "order_channels",
  },
});

clientApi.define("orders", {
  status: "",
  visible_ref: "",
  ext_ref: "",
  currency: "",
  drop_point: null,
  order_lines: [],
  external_comment: "",
  delivery_address: {},
  sender_address: {},
  billing_address: {},
  sold_from_address: {},
  order_channel: {
    jsonApi: "hasOne",
    type: "order_channels",
  },
  shipping_rate: {
    jsonApi: "hasOne",
    type: "shipping_rates",
  },
  shipments: {
    jsonApi: "hasMany",
    type: "shipments",
  },
  packages: {
    jsonApi: "hasMany",
    type: "packages",
  },
}),
  clientApi.define("shipments", {
    carrier_id: "",
    reference: "",
    comment: "",
    service_code: "",
    is_return: false,
    packages: [],
    delivery_address: "",
    sender_address: "",
    billing_address: "",
    pickup_address: "",
    return_address: "",
    tracking_links: [],
    tracking_events: [],
    shipping_rate_id: null,
    carrier: {
      jsonApi: "hasOne",
      type: "carriers",
    },
    order: {
      jsonApi: "hasOne",
      type: "orders",
    },
    shipping_rate: {
      jsonApi: "hasOne",
      type: "shipping_rates",
    },
  });

clientApi.define("packages", {
  weight: 0,
  weight_unit: "g",
  dimensions: {},
  shipment: {
    jsonApi: "hasOne",
    type: "shipments",
  },
  tracking_events: {
    jsonApi: "hasMany",
    type: "tracking_events",
  },
  order_lines: {
    jsonApi: "hasMany",
    type: "order_lines",
  },
});

clientApi.define("tracking_events", {
  status: "",
  time: "",
  description: "",
  event_id: "",
  location: "",
  latitude: "",
  longitude: "",
  tracking_link_id: 0,
  package: {
    jsonApi: "hasOne",
    type: "packages",
  },
  shipment: {
    jsonApi: "hasOne",
    type: "shipments",
  },
});

clientApi.insertMiddlewareAfter("axios-request", {
  name: "401-detector",
  error: function (payload) {
    console.log(payload.response);
    if (payload.response.status === 401) {
      console.log("Logged out");
      store.commit("setToken", null);
    }

    console.log("Payload error", payload);
    return Promise.reject(payload.response.data);
  },
});

clientApi.findAllPages = async function (modelName, params) {
  let data = [];
  let page = 1;
  let links = {};
  let meta = {};
  let errors = [];

  do {
    let {
      data: d,
      links: l,
      errors: e,
      meta: m,
    } = await this.findAll(modelName, { ...params, page: { number: page } });
    page++;
    links = l;
    errors = errors.concat(e);
    meta = { ...meta, ...m };
    data = data.concat(d);
  } while (links.next);

  return { data: data, meta: meta, links: links, errors: errors };
};

window.clientApi = clientApi;
export default clientApi;
